module.exports = __webpack_public_path__ + "static/media/1.b7e98c90.jpg";